module.exports = __webpack_public_path__ + "static/media/DqEveryChildOfflinePrintedMaterials.9f221d94.jpg";